import CompleteDropdown from "../../../../../layout/Dropdowns/CompleteDropdown";

const ProjectCommentTimelineItem = ({
  comment,
  deleteAction,
  viewAction,
  editAction,
  showDropdown = true,
}) => {
  return (
    <div style={{ position: "relative" }}>
    <div style={{
      background: "#f8f9fa",
      borderRadius: "10px",
      padding: "14px 16px",
      borderLeft: "3px solid #1a73e8",
      position: "relative",
    }}>
      {showDropdown && (
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <CompleteDropdown
            deleteAction={deleteAction}
            editAction={editAction}
            viewAction={viewAction}
          />
        </div>
      )}
      <p style={{ margin: 0, fontSize: "1rem", color: "#424242", lineHeight: 1.6, paddingRight: showDropdown ? "32px" : 0 }}>
        {comment.value}
      </p>
    </div>
    </div>
  );
};

export default ProjectCommentTimelineItem;
